const getters = {
    token: (state) => state.user.token,
    /**
     * 是否存在用户信息
     * @returns 返回true：表示用户信息存在
     */
    hasUserInfo: (state) => {
        return JSON.stringify(state.user.userInfo) !== '{}'
    },
    userInfo: (state) => state.user.userInfo,
    menuList: (state) => state.permission.menuList,
    subsystem: (state) => state.permission.subsystem,
    sidebarOpened: (state) => state.app.sidebarOpened
}

export default getters
